import { Box, Flex, Spacer, Wrap, WrapItem } from "@chakra-ui/react";
import {
  Image,
  Button,
  useColorMode,
  Tooltip,
  Container,
  HStack,
  VStack,
} from "@chakra-ui/react";

import { Link } from "react-router-dom";

import Logo from "../images/logo.webp";

interface HeaderNavigationProps {
  isConnected: boolean;
  account: string | undefined;
  isCorrectChainId: boolean;
  toggleConnect: () => void;
  switchNetwork: () => void;
}

const HeaderNavigation: React.FC<HeaderNavigationProps> = (props) => {
  const account = props.account;

  let switchNetworkButton;

  if (!props.isCorrectChainId && props.isConnected) {
    switchNetworkButton = (
      <Button
        size={{ base: "sm", sm: "sm", md: "md" }}
        color={"teal.500"}
        onClick={props.switchNetwork}
      >
        {"Switch Network"}
      </Button>
    );
  }

  return (
    <>
      <Box
        minW={360}
        backgroundColor={"rgba(21, 37, 61, 0.75)"}
        sx={{
          position: "sticky",
          top: "0",
          zIndex: "999",
          backdropFilter: "blur(20px)",
        }}
        borderBottom="1px solid rgba(255, 255, 255, 0.75)"
        px={{ base: 4, md: 0 }}
      >
        <Flex>
          <Flex direction={"column"}>
            <Spacer />
            <Image w={{ base: "96px", md: "96px" }} src={Logo} />
            <Spacer />
          </Flex>
          <Wrap textColor="white" my={8} px={8}>
            <Link to="/">
              <Button variant={"ghost"}>Home</Button>
            </Link>
            <Link to="/royalties">
              <Button variant={"ghost"}>Royalties</Button>
            </Link>
            <Link to="/mint">
              <Button variant={"ghost"}>Mint</Button>
            </Link>
            <Link to="/staking">
              <Button variant={"ghost"}>Stake</Button>
            </Link>
            <Link to="/my-nfts">
              <Button variant={"ghost"}>My NFTs</Button>
            </Link>
            <Link to="/team">
              <Button variant={"ghost"}>Team</Button>
            </Link>
          </Wrap>
          <Spacer />
          <HStack mr={4}>
            <Tooltip
              label={
                account ? `${account.slice(0, 6)}...${account.slice(-4)}` : null
              }
            >
              <Button
                size={{ base: "sm", sm: "sm", md: "md" }}
                onClick={props.toggleConnect}
              >
                {props.isConnected ? "Disconnect" : "Connect Wallet"}
              </Button>
            </Tooltip>
            {switchNetworkButton}
          </HStack>
        </Flex>
      </Box>
    </>
  );
};

export default HeaderNavigation;
